export const EstadosConsultaCobranza = [
  {
    name: 'Todas',
    value: 0
  },
  {
    name: 'Ingresada',
    value: 1
  },
  {
    name: 'Vinculada',
    value: 2
  },
  {
    name: 'Recaudada',
    value: 4
  },
  {
    name: 'Caducada',
    value: 5
  },
]